import { render, staticRenderFns } from "./NewFaqQuestion.vue?vue&type=template&id=1bc9c46d&scoped=true&"
import script from "./NewFaqQuestion.vue?vue&type=script&lang=js&"
export * from "./NewFaqQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc9c46d",
  null
  
)

export default component.exports